export default __webpack_public_path__ + "static/media/GothaBooIta.c62b3eba.otf";